import { oCorpoAberto, nena, retratosFantasmas, aMeninaEoPote, nome, primaKuLebsi, cesariaEvora, percebes

 } from './filmes.data'

const eventos = [
  { filmes: [oCorpoAberto, nena], data: "2024-10-05", hora: "19:00", pais: "Galicia", lugar: "Museo MARCO, Vigo" },
  { filmes: [retratosFantasmas, aMeninaEoPote], data: "2024-10-12", hora: "19:00", pais: "Brasil", lugar: "Museo MARCO, Vigo" },
  { filmes: [nome, primaKuLebsi], data: "2024-10-19", hora: "19:00", pais: "Guinea-Bissau", lugar: "Museo MARCO, Vigo" },
  { filmes: [cesariaEvora, percebes], data: "2024-10-26", hora: "19:00", pais: "Portugal", lugar: "Museo MARCO, Vigo" },
]

export default eventos
